import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Calendar from 'react-calendar';
import { FaCalendarAlt, FaPlus, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import 'react-calendar/dist/Calendar.css';
import './Calendar.css';

function CalendarPage() {
  const [date, setDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showEventForm, setShowEventForm] = useState(false);
  const [events, setEvents] = useState([
    {
      id: 1,
      title: 'Týmový meeting',
      date: new Date(),
      time: '10:00',
      location: 'Online',
      color: '#3b82f6'
    },
    {
      id: 2,
      title: 'Prezentácia projektu',
      date: new Date(),
      time: '14:30',
      location: 'Kancelária',
      color: '#10b981'
    }
  ]);
  const [formData, setFormData] = useState({
    title: '',
    date: '',
    time: '',
    location: '',
    description: ''
  });

  const handleDateChange = (newDate) => {
    setDate(newDate);
    setSelectedDate(newDate);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newEvent = {
      id: events.length + 1,
      ...formData,
      date: new Date(formData.date),
      color: '#' + Math.floor(Math.random()*16777215).toString(16)
    };
    setEvents([...events, newEvent]);
    setFormData({ title: '', date: '', time: '', location: '', description: '' });
    setShowEventForm(false);
  };

  const getEventsForDate = (date) => {
    return events.filter(event => 
      event.date.toDateString() === date.toDateString()
    );
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const dayEvents = getEventsForDate(date);
      if (dayEvents.length > 0) {
        return (
          <div className="calendar-tile-events">
            {dayEvents.slice(0, 3).map((event, index) => (
              <div 
                key={index}
                className="calendar-tile-dot"
                style={{ background: event.color }}
              />
            ))}
          </div>
        );
      }
    }
  };

  return (
    <div className="calendar-page">
      <div className="page-header">
        <h1>Kalendár</h1>
        <motion.button 
          className="btn btn-primary"
          onClick={() => setShowEventForm(!showEventForm)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPlus /> Nová udalosť
        </motion.button>
      </div>

      <div className="calendar-container">
        <div className="calendar-main">
          <motion.div 
            className="calendar-wrapper"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Calendar
              onChange={handleDateChange}
              value={date}
              tileContent={tileContent}
              locale="sk-SK"
            />
          </motion.div>

          {showEventForm && (
            <motion.div 
              className="event-form-container"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <h3>Nová udalosť</h3>
              <form onSubmit={handleSubmit}>
                <div className="input-group">
                  <label>Názov udalosti</label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                    required
                  />
                </div>
                <div className="form-row">
                  <div className="input-group">
                    <label>Dátum</label>
                    <input
                      type="date"
                      value={formData.date}
                      onChange={(e) => setFormData({...formData, date: e.target.value})}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label>Čas</label>
                    <input
                      type="time"
                      value={formData.time}
                      onChange={(e) => setFormData({...formData, time: e.target.value})}
                      required
                    />
                  </div>
                </div>
                <div className="input-group">
                  <label>Miesto</label>
                  <input
                    type="text"
                    value={formData.location}
                    onChange={(e) => setFormData({...formData, location: e.target.value})}
                  />
                </div>
                <div className="input-group">
                  <label>Popis</label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    rows="3"
                  />
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary">
                    Pridať udalosť
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={() => setShowEventForm(false)}
                  >
                    Zrušiť
                  </button>
                </div>
              </form>
            </motion.div>
          )}
        </div>

        <div className="calendar-sidebar">
          <motion.div 
            className="selected-date-info"
            key={selectedDate.toDateString()}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <h2>{selectedDate.toLocaleDateString('sk-SK', { 
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</h2>
          </motion.div>

          <div className="day-events">
            <h3>Udalosti dňa</h3>
            {getEventsForDate(selectedDate).length === 0 ? (
              <div className="no-events">
                <FaCalendarAlt className="no-events-icon" />
                <p>Žiadne udalosti</p>
              </div>
            ) : (
              <div className="events-list">
                {getEventsForDate(selectedDate).map((event) => (
                  <motion.div 
                    key={event.id}
                    className="event-card"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    whileHover={{ scale: 1.02 }}
                    style={{ borderLeft: `4px solid ${event.color}` }}
                  >
                    <h4>{event.title}</h4>
                    <div className="event-details">
                      <span><FaClock /> {event.time}</span>
                      {event.location && (
                        <span><FaMapMarkerAlt /> {event.location}</span>
                      )}
                    </div>
                    {event.description && (
                      <p className="event-description">{event.description}</p>
                    )}
                  </motion.div>
                ))}
              </div>
            )}
          </div>

          <div className="upcoming-events">
            <h3>Najbližšie udalosti</h3>
            <div className="events-list">
              {events
                .filter(event => event.date >= new Date())
                .sort((a, b) => a.date - b.date)
                .slice(0, 5)
                .map((event) => (
                  <div key={event.id} className="upcoming-event-item">
                    <div className="event-date-badge">
                      <span className="day">{event.date.getDate()}</span>
                      <span className="month">
                        {event.date.toLocaleDateString('sk-SK', { month: 'short' })}
                      </span>
                    </div>
                    <div className="event-info">
                      <h5>{event.title}</h5>
                      <span className="event-time">{event.time}</span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendarPage;